module.exports = __webpack_public_path__ + "img/Hypoxia-PDAC_GSE202740.b02dc602.png";